import React from 'react';
import { X } from 'lucide-react';
import { Section } from './Shared';
export const PainPoints = () => {
  const points = ['Buscando entre papeles sueltos qué trabajaste en la sesión anterior', 'Preguntándole al paciente cómo se sentía porque no tenés registro de la vez pasada', 'Sin evidencia de la evolución de tus tratamientos para mostrarle al paciente su progreso', 'Siempre las mismas fichas improvisadas porque no tenés un sistema clínico serio', 'Sin consentimiento informado ni documentación que te proteja legalmente', 'El gabinete sin insumos en plena jornada porque nunca controlás el stock', 'Pacientes que no vuelven porque no perciben el valor profesional de tu trabajo', 'Cada semana empezás el mismo ciclo de caos, una y otra vez'];
  return <Section className="max-w-4xl" data-id="element-227">
      <div className="text-center mb-12" data-id="element-228">
        <h2 className="md:text-5xl font-serif font-bold mb-6 text-[22px]" data-id="element-229">
          ¿Cuántos pacientes más vas a perder por el desorden?
        </h2>
        <p className="text-brand-text/80 mb-4 text-[12px]" data-id="element-230">
          Sos terapeuta en reflexología. Amás lo que hacés. Estudiaste, te
          formaste y sabés que tu trabajo transforma vidas.
        </p>
        <p className="text-brand-text/80 mb-4 text-[12px]" data-id="element-231">
          Pero nadie te dijo que ibas a pasar las noches buscando en qué
          cuaderno anotaste los síntomas del paciente del martes, armando fichas
          que no sirven y llegando a cada sesión sin saber exactamente de dónde
          venías con ese paciente.
        </p>
        <p className="text-xl font-medium text-brand-rose mt-6" data-id="element-232">
          No es falta de vocación. Es falta de un sistema.
        </p>
      </div>

      <div className="glass-panel p-8 md:p-10 rounded-3xl mb-12 pt-[3px] pb-[3px] space-y-[14px] bg-white/60 border-brand-pink/30" data-id="element-233">
        <h3 className="font-medium mb-6 flex items-center text-brand-text/90 text-[18px]" data-id="element-234">
          <X className="w-6 h-6 text-red-500 mr-2" data-id="element-235" /> Lo que pasa sin
          REFLEXO-PRO:
        </h3>
        <ul className="space-y-4" data-id="element-236">
          {points.map((point, i) => <li key={i} className="flex items-start" data-id="element-237">
              <X className="w-5 h-5 text-red-400 mr-3 mt-0.5 shrink-0" data-id="element-238" />
              <span className="text-brand-text/80 text-[12px]" data-id="element-239">{point}</span>
            </li>)}
        </ul>
      </div>

      <div className="text-center" data-id="element-240">
        <h3 className="md:text-3xl font-serif font-bold rose-gradient-text text-[22px]" data-id="element-241">
          ¿Y si esta fuera la última semana que trabajás así?
        </h3>
      </div>
    </Section>;
};